import { defineComponent as $, computed as s, h as e } from "vue";
import { formatLength as t } from "./ghl-ui.es1014.js";
import v from "./ghl-ui.es886.js";
import S from "./ghl-ui.es890.js";
import B from "./ghl-ui.es887.js";
import b from "./ghl-ui.es888.js";
import C from "./ghl-ui.es889.js";
const x = {
  success: e(S, null),
  error: e(B, null),
  warning: e(b, null),
  info: e(C, null)
}, H = $({
  name: "ProgressLine",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    percentage: {
      type: Number,
      default: 0
    },
    railColor: String,
    railStyle: [String, Object],
    fillColor: String,
    status: {
      type: String,
      required: !0
    },
    indicatorPlacement: {
      type: String,
      required: !0
    },
    indicatorTextColor: String,
    unit: {
      type: String,
      default: "%"
    },
    processing: {
      type: Boolean,
      required: !0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    height: [String, Number],
    railBorderRadius: [String, Number],
    fillBorderRadius: [String, Number]
  },
  setup(r, {
    slots: n
  }) {
    const o = s(() => t(r.height)), g = s(() => r.railBorderRadius !== void 0 ? t(r.railBorderRadius) : r.height !== void 0 ? t(r.height, {
      c: 0.5
    }) : ""), f = s(() => r.fillBorderRadius !== void 0 ? t(r.fillBorderRadius) : r.railBorderRadius !== void 0 ? t(r.railBorderRadius) : r.height !== void 0 ? t(r.height, {
      c: 0.5
    }) : "");
    return () => {
      const {
        indicatorPlacement: l,
        railColor: h,
        railStyle: m,
        percentage: d,
        unit: u,
        indicatorTextColor: a,
        status: c,
        showIndicator: p,
        fillColor: y,
        processing: R,
        clsPrefix: i
      } = r;
      return e("div", {
        class: `${i}-progress-content`,
        role: "none"
      }, e("div", {
        class: `${i}-progress-graph`,
        "aria-hidden": !0
      }, e("div", {
        class: [`${i}-progress-graph-line`, {
          [`${i}-progress-graph-line--indicator-${l}`]: !0
        }]
      }, e("div", {
        class: `${i}-progress-graph-line-rail`,
        style: [{
          backgroundColor: h,
          height: o.value,
          borderRadius: g.value
        }, m]
      }, e("div", {
        class: [`${i}-progress-graph-line-fill`, R && `${i}-progress-graph-line-fill--processing`],
        style: {
          maxWidth: `${r.percentage}%`,
          backgroundColor: y,
          height: o.value,
          lineHeight: o.value,
          borderRadius: f.value
        }
      }, l === "inside" ? e("div", {
        class: `${i}-progress-graph-line-indicator`,
        style: {
          color: a
        }
      }, n.default ? n.default() : `${d}${u}`) : null)))), p && l === "outside" ? e("div", null, n.default ? e("div", {
        class: `${i}-progress-custom-content`,
        style: {
          color: a
        },
        role: "none"
      }, n.default()) : c === "default" ? e("div", {
        role: "none",
        class: `${i}-progress-icon ${i}-progress-icon--as-text`,
        style: {
          color: a
        }
      }, d, u) : e("div", {
        class: `${i}-progress-icon`,
        "aria-hidden": !0
      }, e(v, {
        clsPrefix: i
      }, {
        default: () => x[c]
      }))) : null);
    };
  }
});
export {
  H as default
};
